import { abbreviateNumber } from 'js-abbreviation-number';
import type { PortalView } from 'dfx/edge/edge.did';

export const getAbbreviatedContentCount = (portalView: PortalView) => {
  return abbreviateNumber(Number(portalView.content_count), 1);
};
